import ManagedLookup from '../components/ManagedLookup';
import useLookupPage from '../hooks/useLookupPage';
import fields from './fields';
import columns from './columns';

const UtilityBillingTypes = ({ definition }) => {
    const page = useLookupPage('utility-billing-types', columns);
    return <ManagedLookup definition={definition} columns={columns} fields={fields} page={page} />;
};
export default UtilityBillingTypes;
